import React, { useEffect, useState, useRef } from 'react'
import { isMobileOnly } from 'react-device-detect'
import { useHotkeys } from 'react-hotkeys-hook'

import PieTimerAnimation from 'components/common/animations/PieTimer'
import { microphoneEventEmitter, microphoneKeys } from 'helpers/events'
import useLocalAudioToggle from 'hooks/useLocalAudioToggle/useLocalAudioToggle'
import useSpeakingOnMute from 'hooks/useSpeakingOnMute'
import { isDesktop } from 'utils/device'
import { logger } from 'utils/logger'

import { Tooltip, BtnWrapper, AnimWrapper, Button } from './styles'

import { MenuIcon } from '../styles'
import StyledTooltip from '../TooltipWrapper'

import './ToggleAudioButton.css'

const ICON_BASE = '/assets/controls/latest'

export default function ToggleAudioButton(props) {
    const [isAudioEnabled, toggleAudioEnabled] = useLocalAudioToggle()

    useEffect(() => {
        const handleSpeakingOnMute = value => {
            const unmuteSpeakToastElement = document.getElementById(
                'unmute-speak-toast'
            )
            if (unmuteSpeakToastElement) {
                if (value) {
                    unmuteSpeakToastElement.style.setProperty('display', 'flex')
                } else {
                    unmuteSpeakToastElement.style.setProperty('display', 'none')
                }
            }
        }

        microphoneEventEmitter.addListener(
            microphoneKeys.SPEAKING_ON_MUTE,
            handleSpeakingOnMute
        )

        return () => {
            microphoneEventEmitter.removeListener(
                microphoneKeys.SPEAKING_ON_MUTE,
                handleSpeakingOnMute
            )
        }
    }, [])

    useEffect(() => {
        logger.debug(`User audio status : ${isAudioEnabled ? 'on' : 'off'}`)
    }, [isAudioEnabled])

    const [blockAudioTimerAnim, setBlockAudioTimerAnim] = useState(false)
    useEffect(() => {
        blockAudioTimerAnim &&
            setTimeout(() => setBlockAudioTimerAnim(false), 2000)
    }, [blockAudioTimerAnim])

    useSpeakingOnMute(isAudioEnabled)
    const btnRef = useRef()

    // For Audio
    useHotkeys('ctrl+,', event => {
        event.preventDefault()
        btnRef.current && btnRef.current.click()
    })

    const tooltipProps = {
        title: isDesktop
            ? isAudioEnabled
                ? 'mute audio'
                : 'unmute audio'
            : '',
        placement: 'left',
        arrow: true,
        PopperProps: { disablePortal: true },
    }

    const btnProps = {
        onClick: () => {
            if (blockAudioTimerAnim) return
            toggleAudioEnabled()
            setBlockAudioTimerAnim(true)
        },
        disabled: props.disabled,
        'data-cy-audio-toggle': true,
        clicked: !isAudioEnabled,
        isMobile: isMobileOnly,
    }

    const menuIconProps = {
        src: `${ICON_BASE}/${isAudioEnabled ? 'micOn.svg' : 'micOff.svg'}`,
        clicked: !isAudioEnabled,
        alt: 'menu',
    }

    console.count('ToggleAudioButton Component')

    return (
        <>
            {isDesktop && (
                <Tooltip id="unmute-speak-toast">Oh. unmute to speak</Tooltip>
            )}
            <StyledTooltip {...tooltipProps}>
                <BtnWrapper disabled={blockAudioTimerAnim}>
                    {blockAudioTimerAnim && (
                        <AnimWrapper>
                            <PieTimerAnimation />
                        </AnimWrapper>
                    )}
                    <Button {...btnProps} ref={btnRef}>
                        <MenuIcon {...menuIconProps} />
                    </Button>
                </BtnWrapper>
            </StyledTooltip>
        </>
    )
}
